export const headerBundle = {
  caption: {
    ko: "세대별 사용량 비교",
    en: "Household Usage Comparison",
    es: "Comparacion del uso por hogar"
  },
  startDateError: {
    ko: "시작일은 종료일보다 늦을 수 없습니다.",
    en: "Start date cannot be later than the end date.",
    es: "La fecha de inicio no puede ser posterior a la fecha de finalización."
  },
  search: { ko: "검색", en: "Search", es: "Buscar" },
  startDate: { ko: "시작일", en: "Start Date", es: "Fecha de inicio" },
  endDate: { ko: "종료일", en: "End Date", es: "Fecha de fin" }
}
